<template>
  <div class="cursorStyles_info">    
    <!-- <div><span>{{ weatherInfo }}</span></div> -->
    <!-- <div><span>LocalStatus:{{ localStatusInfo }}</span></div> -->
    <!-- <div><span>地图模式:{{ localModeInfo }}</span></div>
    <div><span>油门:{{ vehicleThrottle }}</span></div>
    <div><span>刹车:{{ vehicleBrake }}</span></div>
    <div><span>安全模块刹车:{{ vanguardBrake }}</span></div> -->
  </div>
</template>

<script lang="ts" setup>
import { watch, ref } from 'vue'
import { useStore } from '@/store/index'
import { load_vehicle_weather } from "./js/vehicle_weatherType";
import { useFrameDataStore } from "@/store/frameDataStore";
import { getEnumName_LocStatus, getEnumName_LocMode, getEnumName_AnomalySeverity, getEnumName_RoadType } from "@/utils/enumHelperDataView";

const store = useStore()
let frameDataStore = useFrameDataStore();
let weatherInfo = ref('weatherInfo:')
let localStatusInfo = ref('')
let localModeInfo = ref('')
let vehicleThrottle = ref('')
let vehicleBrake = ref('')
let vanguardBrake = ref('')
watch(() => frameDataStore.currentData, (e:any) => {
  if (e?.vehicleData) {
    // weatherInfo.value = load_vehicle_weather(e.vehicleData)
    // localStatusInfo.value = getEnumName_LocStatus(e.vehicleData.locStatus);
    localModeInfo.value = getEnumName_LocMode(e.vehicleData.locMode);
    vehicleThrottle.value = (e.vehicleData.controlDebugData?.vehicleThrottle||0).toFixed(2);
    vehicleBrake.value = (e.vehicleData.controlDebugData?.vehicleBrake||0).toFixed(2);   
    vanguardBrake.value = (e.vehicleData.controlDebugData?.vanguardBrake||0).toFixed(2);   
  }
})

</script>
<style lang="less" scoped>
.cursorStyles_info {
  position: fixed;
  top: 5px;
  left: 10px;
  z-index: 50;
  text-align: left;
  display: flex;
  flex-direction: column;

  div {
    margin-top: 2px;
    height: 20px;
    line-height: 20px;
    background: rgba(255, 255, 255, 0.2);
    color: #fff;
    border-radius: 5px;
    padding: 0 5px;
    display: block;
    /* 将 div 元素设置为行内块元素 */
  }
}
</style>
